import { CreateNodeShortcutCommand, NewNodeFloatingMenu } from './NewNodeFloatingMenu';
import { RoundedPlus } from './RoundedPlus';
import { ExtendedReactElement } from '@/utils/types';

export const CreateNodeFloatingMenuButton = ({
	className,
	scale,
	onShortcutClick,
}: ExtendedReactElement<{ onShortcutClick: (shortcut: CreateNodeShortcutCommand) => void; scale: number }>) => (
	<NewNodeFloatingMenu onShortcutClick={onShortcutClick} style={{ transform: `scale(${scale})` }}>
		<RoundedPlus className={className} />
	</NewNodeFloatingMenu>
);
